var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLogout = function SvgIconLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.751,
    height: 18.739
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.369 18.74a9.37 9.37 0 1 1 3.663-18 .586.586 0 1 1-.459 1.079 8.2 8.2 0 1 0 0 15.094.586.586 0 1 1 .459 1.079 9.3 9.3 0 0 1-3.661.743Z",
    "data-name": "Path 5933"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.975 10.28H9.061a.782.782 0 1 1 0-1.564h8.914a.782.782 0 1 1 0 1.564",
    "data-name": "Path 5934"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.887 14.845a.782.782 0 0 1-.6-1.287l3.44-4.073-3.454-4.32a.782.782 0 0 1 1.222-.977l4.256 5.323-4.269 5.056a.78.78 0 0 1-.595.278",
    "data-name": "Path 5935"
  })));
};
export default SvgIconLogout;